﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver, { resolveRawText } from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';

import AFamiliesituasjonValg from './Utilities/A-FamiliesituasjonValg';
import BValg from './Utilities/B-Valg';
import CSoskenValg from './Utilities/C-SoskenValg';
import VeilederIasDto from './Models/VeilederIasDto';
import { VeilederIasAppState } from './Store';
import * as Ids from './Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import ResultatContainer from './Components/ResultatComponent';
import TabellContainer from './Components/TabellComponent';
import { Satser } from './Utilities/SatserApi';
import * as VeilederLogikk from './Veileder';
import ModalKlikkContainer from './Components/ModalKlikkComponent';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederIasDto>();

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext, satser } = this.props;
        const { epiModel } = this.props.epiContext;

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.aFamiliesituasjon != undefined) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                }
            }

            if (!analyticsState.fullfort) {
                if (resultat.visResultat || resultat.visTabell) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                }
            }
        }

        if (resultat.visGenerellFeil || epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            let tabellElement: JSX.Element | undefined;

            if (resultat.visTabell && satser != null) {
                const tabell = VeilederLogikk.getTabell(valg, satser);
                if (tabell != null) {
                    tabellElement = <TabellContainer valg={valg} tabell={tabell} eventId={eventId} />;
                } else {
                    return <FeilmeldingComponent />;
                }
            }

            const forklaringOgModalKlikk: JSX.Element = (
                <div>
                    {contentResolver(epiContext, 'infoEnForelder')}
                    {
                        <ModalKlikkContainer
                            valg={valg}
                            lenketekst={contentResolver(epiContext, 'lenketekstEnForelder')}
                            overskrift={contentResolver(epiContext, 'overskriftEnForelderModal')}
                            content={contentResolver(epiContext, 'contentEnForelderModal')}
                            ariaLabel={resolveRawText(epiContext, 'ariaLabelEnForelderModal')}
                            eventId={eventId}
                        />
                    }
                </div>
            );

            return (
                <div className="c-veileder">
                    {registerEvents()}
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittelFamiliesituasjon')}
                        forklaring={<p>{contentResolver(epiContext, 'infoFamiliesituasjon')}</p>}
                        sporsmal="ledetekstFamiliesituasjon"
                        valg={AFamiliesituasjonValg.aValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aFamiliesituasjon: nyttValg });
                        }}
                        neverCollapse={true}
                        value={valg.aFamiliesituasjon}
                    />
                    {resultat.visResultat && <ResultatContainer valg={valg} eventId={eventId} />}
                    {resultat.visBoksB && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksB}
                            tittel={contentResolver(epiContext, 'overskriftSivilstatus')}
                            forklaring={
                                <div>
                                    <p>{contentResolver(epiContext, 'infoSivilstatus')}</p>
                                </div>
                            }
                            sporsmal="ledetekstSivilstatus"
                            valg={BValg.bValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bSivilstatus: nyttValg });
                            }}
                            value={valg.bSivilstatus}
                            classModifier="c-veileder__panel--secondary-pistasj-light"
                        />
                    )}
                    {resultat.visBoksBx && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksBx}
                            tittel={contentResolver(epiContext, 'overskriftEnForelder')}
                            forklaring={forklaringOgModalKlikk}
                            sporsmal="ledetekstEnForelder"
                            valg={BValg.bxValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ bEnForelder: nyttValg });
                            }}
                            value={valg.bEnForelder}
                            classModifier="c-veileder__panel--secondary-pistasj-light"
                        />
                    )}
                    {resultat.visBoksC && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksC}
                            tittel={contentResolver(epiContext, 'overskriftSosken')}
                            forklaring={
                                <div>
                                    <p>{contentResolver(epiContext, 'infoSosken')}</p>
                                </div>
                            }
                            sporsmal="ledetekstSosken"
                            valg={CSoskenValg.cValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cSosken: nyttValg });
                            }}
                            value={valg.cSosken}
                            classModifier="c-veileder__panel--cotton-candy"
                        />
                    )}
                    {tabellElement}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederIasDto>;
    resultat: ResultatValg;
    satser: Satser | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederIasAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederIasAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
